import { motion } from "framer-motion";
import * as Fa from "react-icons/fa";
import { INDUSTRIES } from "../data/content";

const Industries = () => (
    <section id="industries" data-testid="industries-section" className="relative py-20 sm:py-28 bg-gradient-to-br from-brand-700 via-brand-800 to-slate-950 overflow-hidden">
        <div className="absolute inset-0 bg-medical-grid opacity-20" />
        <div className="absolute top-0 left-1/3 w-96 h-96 bg-brand-400/20 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center max-w-2xl mx-auto mb-14">
                <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-200 mb-4">Industries We Serve</div>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white">
                    Trusted by Every Corner of <span className="text-sky-300">Healthcare</span>
                </h2>
            </motion.div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {INDUSTRIES.map((ind, i) => {
                    const Icon = Fa[ind.icon] || Fa.FaHospital;
                    return (
                        <motion.div
                            key={ind.name}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: i * 0.06 }}
                            data-testid={`industry-${i}`}
                            className="group p-6 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white hover:border-white text-center transition-all"
                        >
                            <div className="w-14 h-14 mx-auto rounded-2xl bg-white/15 group-hover:bg-brand-50 flex items-center justify-center text-2xl text-white group-hover:text-brand-700 transition-all">
                                <Icon />
                            </div>
                            <div className="mt-3 font-heading font-semibold text-white group-hover:text-slate-900 text-sm transition-colors">{ind.name}</div>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    </section>
);

export default Industries;
